import React from 'react'

const ViewBarArrowTimeUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M19.6 18.6l4.1 2.5-.7 1.2.8-1.3-4.2-2.5zM18.2 13.7h1.4v.1h-1.4z" />
    <path
      fill="none"
      d="M19.1 11c-4.1 0-7.4 3.3-7.4 7.4 0 4.1 3.3 7.4 7.4 7.4 4.1 0 7.4-3.3 7.4-7.4 0-4.1-3.3-7.4-7.4-7.4zM23 22.3l-4.8-3v-5.6h1.4v4.8l4.2 2.5-.8 1.3z"
    />
    <path d="M12.7 7.6c.4-.5.4-1.2 0-1.6L7.3.6C7.1.4 6.8.3 6.5.3s-.6.1-.8.3L.3 6c-.4.4-.4 1.1 0 1.6.4.4 1.2.4 1.6 0l3.5-3.5v22.8c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1V4.1l3.5 3.5c.4.4 1.2.4 1.6 0zM19.6 18.6v-4.8h-1.4v5.5l4.8 3 .7-1.2z" />
    <path d="M19.1 9.1c-5.1 0-9.3 4.2-9.3 9.3 0 5.1 4.2 9.3 9.3 9.3 5.1 0 9.3-4.2 9.3-9.3 0-5.1-4.2-9.3-9.3-9.3zm0 16.7c-4.1 0-7.4-3.3-7.4-7.4 0-4.1 3.3-7.4 7.4-7.4 4.1 0 7.4 3.3 7.4 7.4 0 4.1-3.3 7.4-7.4 7.4z" />
  </svg>
)

export default ViewBarArrowTimeUp
